export default __webpack_public_path__ + "static/media/wdt-logo.759d7012.png";